import { FC, useState } from "react";
import Section from "components/corphurusato/parts/Section";
import Headline, { Big } from "components/corphurusato/parts/Headline";
import SubHeadline from "components/corphurusato/parts/SubHeadline";
import SeeMoreButton from "components/corphurusato/parts/SeeMoreButton";
import styled from "styled-components";
import Content from "components/corphurusato/parts/Content";
import Paragraph from "components/corphurusato/parts/Paragraph";
import BottomSlide from "components/corphurusato/parts/BottomSlide";

const Faq: FC = () => {
  const [showsMore, setShowsMore] = useState(false);
  return (
    <Section>
      <Headline color={"#83D960"}>
        よくある<Big>質問</Big>
        <HeadlineImage src="/image/lp/corphurusato/faq/title_05_illust.png" />
      </Headline>
      <Content>
        <FaqItem>
          <SubHeadline
            label={
              <>
                個人版ふるさと納税のように
                <OnlySpBr />
                返礼品はもらえますか？
              </>
            }
            color={"#83D960"}
          />
          <AnswerArea>
            <Icon src="/image/lp/corphurusato/faq/answer.png" />
            <StyledParagraph>
              返礼品は受け取れません。
              <br />
              代わりに、企業様のメリットになる社会貢献に関するPRなどを受けることができます。
            </StyledParagraph>
          </AnswerArea>
        </FaqItem>
        <FaqItem>
          <SubHeadline
            label={
              <>
                おおよそどのぐらいの額の
                <OnlySpBr />
                税金控除を受けられますか？
              </>
            }
            color={"#83D960"}
          />
          <AnswerArea>
            <Icon src="/image/lp/corphurusato/faq/answer.png" />
            <StyledParagraph>
              9割前後の控除が受けられます。
              <br />
              詳細はシミュレーターを活用しご確認ください。
            </StyledParagraph>
          </AnswerArea>
        </FaqItem>
        <FaqItem>
          <SubHeadline
            label={
              <>
                株式会社に限らず、
                <OnlySpBr />
                法人であれば寄附はできますか？
              </>
            }
            color={"#83D960"}
          />
          <AnswerArea>
            <Icon src="/image/lp/corphurusato/faq/answer.png" />
            <StyledParagraph>可能です。</StyledParagraph>
          </AnswerArea>
        </FaqItem>
        {!showsMore && (
          <SeeMoreButtonArea>
            <SeeMoreButton
              label="もっと見る"
              color={"#83D960"}
              arrowImage="/image/lp/corphurusato/faq/down_02_over.png"
              onClick={() => setShowsMore(true)}
            />
          </SeeMoreButtonArea>
        )}
        <BottomSlide in={showsMore}>
          <div>
            <FaqItem>
              <SubHeadline
                label={
                  <>
                    相談した上で寄附を
                    <OnlySpBr />
                    検討したいのですが可能ですか？
                  </>
                }
                color={"#83D960"}
              />
              <AnswerArea>
                <Icon src="/image/lp/corphurusato/faq/answer.png" />
                <StyledParagraph>
                  可能です。各プロジェクトのお問い合わせボタンよりご連絡ください。
                  <br />
                  企業様ごとの利益を元に、最適な寄附額をご提案いたします。
                </StyledParagraph>
              </AnswerArea>
            </FaqItem>
            <FaqItem>
              <SubHeadline label="利用可能な決済手段は何ですか？" color={"#83D960"} />
              <AnswerArea>
                <Icon src="/image/lp/corphurusato/faq/answer.png" />
                <StyledParagraph>企業版ふるさと納税は、銀行振込のみになります。</StyledParagraph>
              </AnswerArea>
            </FaqItem>
            <LinkArea>
              <ZendeskLink href="https://animefund.zendesk.com/hc/ja/categories/900000172906">その他よくある質問はこちら»</ZendeskLink>
            </LinkArea>
          </div>
        </BottomSlide>
      </Content>
    </Section>
  );
};

export default Faq;

const OnlySpBr = styled.br`
  @media screen and (min-width: 961px) {
    display: none;
  }
`;

const SeeMoreButtonArea = styled.div`
  margin: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FaqItem = styled.div``;
const AnswerArea = styled.div`
  position: relative;
`;
const Icon = styled.img`
  position: absolute;

  @media screen and (max-width: 960px) {
    left: 0;
    height: 26px;
    width: 26px;
  }

  @media screen and (min-width: 961px) {
    left: 5%;
    height: 32px;
    width: 32px;
  }
`;
const StyledParagraph = styled(Paragraph)`
  @media screen and (max-width: 960px) {
    && {
      margin: 10px 5% 10px 10%;
    }
  }

  @media screen and (min-width: 961px) {
    && {
      margin: 20px 10%;
    }
  }
`;

const HeadlineImage = styled.img`
  @media screen and (max-width: 960px) {
    display: none;
  }

  @media screen and (min-width: 961px) {
    margin-left: 10px;
    width: 40px;
    height: 42px;
  }
`;

const LinkArea = styled.div`
  margin-top: 20px;
  text-align: right;
`;

const ZendeskLink = styled.a`
  text-decoration: underline;
  color: #777;
`;
